export default {
  mapView: {
    'routeTo': 'Naviga fino a questo luogo',
    'polygonDetails': 'Dettagli poligono',
    'polygon': 'Poligono',
    'whatIsHere': 'Cosa c\'è qui?',
    'directionsFromHere': 'Direzioni da qui',
    'fitAllFeatures': 'Mostra tutto',
    'addRouteStop': 'Aggiungi una fermata qui',
    'addDestinationToRoute': 'Aggiungi destinazione all\'itinerario',
    'acquirePositionErrors': {
      'generic': 'Non è stato possibile acquisire la tua posizione perché non è stato autorizzato o il tuo browser/dispositivo non supporta la funzione.',
      'unavailable': 'Secondo il tuo browser/dispositivo, la tua posizione non è momentaneamente disponibile. Assicurati di aver configurato propriamente le impostazioni di geolocalizzazione.',
      'permissionDenied': 'Non è stato possibile acquisire la tua posizione perché il tuo browser/dispositivo nega l\'accesso. Riprova cambiando le impostazioni del tuo browser/dispositivo e clicca di nuovo sul pulsante "La mia posizione"',
      'timeout': 'Il tuo browser/dispositivo ha restituito un "timeout" acquisendo la tua posizione. Riprova cliccando sul pulsante "La mia positione"'
    },
    'yourCurrentLocation': 'La mia posizione',
    'options': 'Opzioni',
    'polylineMeasure': {
      'bearingTextIn': 'Entrata',
      'bearingTextOut': 'Uscita',
      'tooltipTextDragAndDelete': 'Trascina per <b>muovere</b><br>Premi SHIFT e clicca per <b>cancellare</b>',
      'tooltipTextResume': '<br>Premi CTRL e clicca per <b>continuare la linea</b>',
      'tooltipTextDelete': 'Premi SHIFT e clicca per <b> eliminare il punto </b>',
      'tooltipTextAdd': 'Premi CTRL e clicca per <b>aggiungere un punto</b>',
      'clearControlTitle': 'Cancella misurazioni',
      'measureControlTitleOn': 'Attiva misurazione distanza',
      'measureControlTitleOff': 'Disattiva misurazione distanza',
      'unitControlTitle': {
        'text': 'Cambia unità',
        'metres': 'metri',
        'landmiles': 'miglia terrestri',
        'nauticalmiles': 'miglia nautiche'
      },
      'clearControlLabel': '&times',
      'measureControlLabel': '&#8614;',
      'measureControlClasses': [],
      'unitControlLabel': {
        'metres': 'm',
        'kilometres': 'km',
        'feet': 'ft',
        'landmiles': 'mi',
        'nauticalmiles': 'M'
      }
    },
    'defineAvoidPolygon': 'Definisci i poligoni da evitare nel calcolo dell\'itinerario',
    'defineAvoidRectangle': 'Definisci i rettangoli da evitare nel calcolo dell\'itinerario',
    'youCantIntersectPolygons': 'Non puoi intersecare poligoni',
    'polygonArea': 'Area poligono',
    'highlighting': 'Evidenziazione',
    'accuracy': 'Accuratezza',
    'youCanCenterAtYourLocationLater': 'Puoi centrare la mappa alla tua posizione attuale cliccando il pulsante "La mia posizione"',
    'yourLocation': 'Usa la mia posizione',
    'setMyLocationAsMapCenter': 'Vuoi centrare la mappa alla tua posizione attuale? Ciò migliorerà la precisione della ricerca. Dovrai autorizzare quando richiesto.',
    'removePlace': 'Rimuovi luogo',
    'viewOnORS': 'Vedi su ORS',
    'moveMapPositionToLeft': 'Muovi verso sinistra',
    'moveMapPositionToRight': 'Muovi verso destra',
    'moveMapPositionToUp': 'Muovi verso l\'alto',
    'moveMapPositionToDown': 'Muovi verso il basso',
    'toggleDirect': 'Attiva/disattiva via diretta in linea d\'aria da qui al prossimo luogo',
    'heightGraph': {
      'distance': 'Distanza',
      'elevation': 'Altitudine',
      'segment_length': 'Lunghezza segmento',
      'type': 'Tipo',
      'legend': 'Legenda'
    },
    'editShape': 'Edita forma',
    'remove': 'Rimuovi',
    'avoidPolygonSaved': 'Poligono da evitare salvato',
    'avoidPolygonRemoved': 'Poligono da evitare rimosso',
    'avoidPolygonNotRemoved': 'Non è stato possibile rimuovere il poligono da evitare',
    'avoidPolygonNotSaved': 'Non è stato possibile salvare il poligono da evitare',
    'polygonEditModeEnabled': 'Dopo aver finito clicca da qualsiasi parte per salvare i cambiamenti',
    'customTileProvider': 'Mattonella (tile) fornita dall\'utente',
    'gestureHandling': {      
      'touch': 'Utilizza due dita per spostare la mappa',
      'scroll': 'Utilizza CTRL + scorrimento per eseguire lo zoom della mappa',
      'scrollMac': 'Utilizza ⌘ + scorrimento per eseguire lo zoom della mappa'
    }
  }
}
